'use strict';

class Ajax {
    /**
     *
     * @param cls - selector for append
     * @param params - json, (url and data)
     *
     * Example:
     * let callback = function() {};
     *
     * let request = new AjaxParts({
     *    url:url,
     *    data:false,
     *    callback:callback
     * });
     */
    constructor(params) {
        this.xhr = false;
        this.params = params;
    }
    abort() {
        if (this.xhr && this.xhr.readyState != 4) {
            this.xhr.abort();
        }
    }
    ajaxRequest() {
        let params = this.params;
        this.xhr = $.ajax({
            url: params.url,
            type: 'POST',
            dataType: 'json',
            data: params.data,
            beforeSend: function () {
                //TODO add before send params, maybe block form and etc..
            },
            complete: function () {
                //TODO add complete request action, maybe unblock form and etc..
            },
            success: function (data) {
                if (params.callback) {
                    params.callback(data);
                    return true;
                }

                return false;
            },
            error: function (data) {
                if (data.statusText == 'abort'){
                    return;
                }
                let notice = new Notice(false, 'Произошла ошибка, попробуйте позже!')
                if (params.error) {
                    params.error(data);
                }
                notice.showNotice();
            }
        });
    }
    ajaxRequestDOM() {
        let params = this.params;

        this.xhr = $.ajax({
            url: params.url,
            type: 'POST',
            dataType: 'json',
            processData: false,
            contentType: false,
            data: params.data,
            beforeSend: function () {
                //TODO add before send params, maybe block form and etc..
            },
            complete: function () {
                //TODO add complete request action, maybe unblock form and etc..
            },
            success: function (data) {
                if (params.callback) {
                    params.callback(data);
                    return true;
                }

                return false;
            },
            error: function (data) {                
                let notice = new Notice(false, 'Произошла ошибка, попробуйте позже!')
                notice.showNotice();
            }
        });
    }
}

